import React from 'react'
import { Button } from '@mc/design-system'
import { ActionCtaProps } from '../../../../types/headerActionProps'

export interface SelectButtonProps extends ActionCtaProps {
  isSelected?: boolean
  onClick: () => void
  fullWidth?: boolean
}

export const SelectButton = ({
  isSelected,
  onClick,
  label,
  selectedLabel,
  unselectedLabel,
  fullWidth,
}: SelectButtonProps) => (
  <Button
    aria-label={label}
    aria-pressed={isSelected}
    kind={isSelected ? 'primary' : 'tertiary'}
    size='sm'
    fullWidth={fullWidth}
    onClick={onClick}
  >
    {isSelected ? selectedLabel : unselectedLabel}
  </Button>
)
